import { useEffect, useState } from "react";
import { Moon, Sun } from "@phosphor-icons/react";

const KEY = "cr-theme";
const EVENT = "cr-theme-change";
const read = () => (localStorage.getItem(KEY) === "light" ? "light" : "dark");

const useThemeValue = () => {
  const [theme, setTheme] = useState(read);
  useEffect(() => {
    const sync = () => setTheme(read());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return theme;
};

// App-only light mode: dark by default, remembered per device, removed when leaving the app.
export const useAppTheme = () => {
  const theme = useThemeValue();
  useEffect(() => {
    document.documentElement.classList.toggle("theme-light", theme === "light");
    return () => document.documentElement.classList.remove("theme-light");
  }, [theme]);
  return theme;
};

export const ThemeToggle = ({ slim, testid = "theme-toggle" }) => {
  const light = useThemeValue() === "light";
  const flip = () => {
    localStorage.setItem(KEY, light ? "dark" : "light");
    window.dispatchEvent(new Event(EVENT));
  };
  const label = light ? "Dark mode" : "Light mode";
  return (
    <button data-testid={testid} onClick={flip} title={`Switch to ${label.toLowerCase()}`} aria-label={`Switch to ${label.toLowerCase()}`}
      className={`flex items-center rounded-lg text-sm text-[#A3A3A3] hover:text-white hover:bg-[#121212] transition-colors ${slim ? "h-10 w-10 justify-center" : "gap-3 px-3 py-2.5"}`}>
      {light ? <Moon size={18} /> : <Sun size={18} />}{!slim && label}
    </button>
  );
};
